import * as yup from "yup";

export const MIN_REVIEWS_TO_SHOW_LIMIT = 50;
/** The column holding the link is nvarchar(500). */
export const GOOGLE_REVIEW_URL_MAX_LENGTH = 500;

export interface IReviewSettingsFormModel {
  reviewRequestsEnabled: boolean;
  showReviewsPublicly: boolean;
  minReviewsToShow: number;
  /** Empty when the studio has no Google review link. */
  googleReviewUrl: string;
}

const RANGE_MESSAGE = `Между 1 и ${MIN_REVIEWS_TO_SHOW_LIMIT}`;
const HTTPS_MESSAGE = "Линкът трябва да започва с https://";
const URL_LENGTH_MESSAGE = `Максимум ${GOOGLE_REVIEW_URL_MAX_LENGTH} символа`;

export const reviewSettingsSchema: yup.ObjectSchema<IReviewSettingsFormModel> =
  yup.object({
    reviewRequestsEnabled: yup.boolean().defined(),
    showReviewsPublicly: yup.boolean().defined(),
    minReviewsToShow: yup
      .number()
      .typeError(RANGE_MESSAGE)
      .required(RANGE_MESSAGE)
      .integer(RANGE_MESSAGE)
      .min(1, RANGE_MESSAGE)
      .max(MIN_REVIEWS_TO_SHOW_LIMIT, RANGE_MESSAGE),
    googleReviewUrl: yup
      .string()
      .defined()
      .max(GOOGLE_REVIEW_URL_MAX_LENGTH, URL_LENGTH_MESSAGE)
      .test(
        "https",
        HTTPS_MESSAGE,
        (value) => !value?.trim() || /^https:\/\/\S+$/i.test(value.trim()),
      ),
  });

export const reviewSettingsDefaultValues: IReviewSettingsFormModel = {
  reviewRequestsEnabled: true,
  showReviewsPublicly: true,
  minReviewsToShow: 3,
  googleReviewUrl: "",
};
